export default {
  title: 'Website übertragen',
  buttons: {
    cancel: 'Abbrechen',
    transfer: 'Übertragen',
  },
  fields: {
    target_franchise: {
      label: 'Ziel-Franchise',
      description: 'Wählen Sie die Franchise aus, an die die Website übertragen werden soll',
    },
    sync_companies: {
      label: 'Firmenzuordnungen',
      description: 'Ordnen Sie Unternehmen aus der Ziel-Franchise den Storefront-Unternehmen zu',
      franchise_company: 'Franchise-Unternehmen',
      storefront_company: 'Storefront-Unternehmen',
      select_franchise_company: 'Franchise-Unternehmen auswählen',
      select_storefront_company: 'Storefront-Unternehmen auswählen',
      franchise_company_required: 'Franchise-Unternehmen ist erforderlich',
      storefront_company_required: 'Storefront-Unternehmen ist erforderlich',
    },
  },
  toasts: {
    failed_to_load_companies: 'Laden der Unternehmen fehlgeschlagen',
    no_companies_selected: 'Bitte fügen Sie mindestens eine Firmenzuordnung hinzu',
    failed_to_transfer: 'Übertragung der Website fehlgeschlagen',
    transfer_success: 'Website erfolgreich übertragen',
    franchise_already_connected: 'Ziel-Franchise ist bereits mit einer Website verbunden',
  },
};
